import { render } from "./Asistentes.vue?vue&type=template&id=a60222c0"
import script from "./Asistentes.vue?vue&type=script&lang=js"
export * from "./Asistentes.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Trabajo\\Raxar\\backoffice-base-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__